export default __webpack_public_path__ + "static/media/harshit.9707fb9b.jpg";